"use client";

import { cn } from "@/app/lib/utils";

interface DragHandleProps {
  onMouseDown: (e: React.MouseEvent) => void;
  onTouchStart: (e: React.TouchEvent) => void;
  className?: string;
}

export function DragHandle({ onMouseDown, onTouchStart, className }: DragHandleProps) {
  return (
    <div
      className={cn(
        "absolute left-0 top-0 bottom-0 group cursor-ew-resize",
        "w-[1px] hover:w-1 bg-gray-200 hover:bg-gray-300",
        "transition-all duration-150",
        className
      )}
      onMouseDown={onMouseDown}
      onTouchStart={onTouchStart}
    >
      {/* Dots indicator that appears on hover */}
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        <div className="flex flex-col gap-1">
          <div className="w-1 h-1 bg-gray-500 rounded-full" />
          <div className="w-1 h-1 bg-gray-500 rounded-full" />
          <div className="w-1 h-1 bg-gray-500 rounded-full" />
        </div>
      </div>
    </div>
  );
}